import { motion } from "motion/react";
import { imgLoader } from "@/shared/assets/img";

export default function LoadingScreenLoader() {
  return (
    <div className="relative">
      <p className="absolute z-20 -top-2.5 left-1/2 text-18 text-center text-white font-black uppercase -translate-x-1/2">
        Вход в игру
      </p>
      <div
        className="w-[74.5rem] h-[7.5625rem] bg-gradient-to-t from-[#A1A1A1] to-[#3C3C3C] opacity-[0.2]"
        style={{
          WebkitMaskImage: `url(${imgLoader})`,
          WebkitMaskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
        }}
      />
      <motion.div
        className="absolute top-0 left-1/2 w-[74.5rem] h-[7.5625rem] bg-[linear-gradient(90deg,transparent_0%,transparent_40%,#AB292980_45%,#E53F3F_50%,#AB292980_55%,transparent_60%,transparent_100%)] -translate-x-1/2"
        animate={{ backgroundPosition: ["90% 0%", "10% 100%"] }}
        transition={{
          duration: 4,
          repeat: Infinity,
          repeatType: "reverse",
          ease: "linear",
        }}
        style={{
          WebkitMaskImage: "url(/svg/loadingScreen/loader.svg)",
          WebkitMaskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          backgroundSize: "200% 100%",
        }}
      />
      <p className="absolute z-20 -bottom-1.5 left-1/2 text-16 text-center text-white font-medium opacity-[0.7] -translate-x-1/2">
        Подключение к серверу
      </p>
    </div>
  );
}
